<template>
    <div>
        <fs-lightbox-vue
            :toggler="toggler"
            :slide="slide"
            :sources="job.company.images"
            :on-close="onCloseModal"
            :on-open="onOpenModal"
        >
        </fs-lightbox-vue>

        <div class="company-images-wrapper only-desktop">
            <div class="company-images-row" v-for="(imgsChunk, index) in imagesChunk" :key="index">
            <div
                v-for="(image, indx) in imgsChunk"
                :key="`gallery-${indx}`"
                @click="openLightboxOnSlide((index * 4) + indx + 1)"
                class="company-image cursor-pointer"
                :style="`background-image: url(${image})`"
            ></div>

            <!-- fill empty images spaces to the right, if needed -->
            <template v-if="((4 - imgsChunk.length) > 0)">
                <div class="company-image" v-for="(_, newIndx) in (4 - imgsChunk.length)" :key="`empty-${newIndx}`"></div>
            </template>
            </div>
        </div>

        <!-- mobile -->
        <div class="company-images-wrapper only-mobile">
            <div class="company-images-row">
            <carousel :pagination-enabled="false" :per-page="1">
                <slide v-for="(image, index) in job.company.images" :key="index">
                <div
                    @click="openLightboxOnSlide(index + 1)"
                    class="company-image"
                    :style="`background-image: url(${image})`"
                ></div>
                </slide>
            </carousel>
            </div>
        </div>
    </div>
</template>
<script type="text/javascript">

    import FsLightboxVue from "fslightbox-vue";
    import chunk from 'lodash/chunk';

    export default{

        props: {
            job: {
                type: Object
            }
        },

        components: {
            'fs-lightbox-vue': FsLightboxVue
        },

        data() {
            return {
                slide: 0,
                toggler: false
            }
        },

        computed: {
            imagesChunk() {
                return chunk(this.job.company.images, 4);
            }
        },

        methods: {
            onOpenModal() {
                document.body.scrollTop = this.scrollYPos;
                document.documentElement.scrollTop = this.scrollYPos;
            },
            onCloseModal() {
                document.body.scrollTop = this.scrollYPos;
                document.documentElement.scrollTop = this.scrollYPos;
            },
            openLightboxOnSlide: function(number) {
                this.scrollYPos = document.documentElement.scrollTop || document.body.scrollTop || window.scrollY;
                this.slide = number;
                this.toggler = !this.toggler;
            }
        }
    }
</script>